import './App.css';
import { Content } from './content/content';

function App() {
  return (
    <div className="App">

      <Content />
      
    </div>
  );
}

export default App;
